// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SponsorVariant1_wrapper__7Wg1E","logo":"SponsorVariant1_logo__ELcbx","logoText":"SponsorVariant1_logoText__c0V_6"};